import { Type } from "class-transformer";
import { Objects } from "src/modules/utils/shared/objects";
import { Strings } from "src/modules/utils/shared/strings";
import { EnaioObjectId } from "./EnaioObjectId";

export class EnaioMetaDataField {
    //netgen start
    @Type(() => EnaioObjectId)
    field: EnaioObjectId;
    value: any;
    //netgen end

    constructor(field: EnaioObjectId, value: any) {
        this.field = field;
        this.value = value;
    }

    getDisplayValue(): string {
        if (Strings.regexMatches(Objects.toString(this.value), "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}")) {
            return this.value === "0001-01-01T00:00:00" ? "" : new Date(Objects.toString(this.value)).toLocaleString();
        }
        else {
            return Objects.toString(this.value);
        }
    }


}